import { ChevronLeft, ChevronRight } from "lucide-react";

import { Button } from "@/components/ui/button";

interface PaginationProps {
  total: number;
  limit: number;
  offset: number;
  onPageChange: (offset: number) => void;
}

/** Previous/next pager matching the backend limit/offset contract. */
export function Pagination({ total, limit, offset, onPageChange }: PaginationProps) {
  const page = Math.floor(offset / limit);
  const pages = Math.max(1, Math.ceil(total / limit));
  const hasPrevious = page > 0;
  const hasNext = page + 1 < pages;

  return (
    <div className="flex items-center justify-between text-sm">
      <span className="text-muted-foreground">{total} results</span>
      <div className="flex items-center gap-2">
        <Button
          variant="outline"
          size="sm"
          disabled={!hasPrevious}
          onClick={() => onPageChange((page - 1) * limit)}
        >
          <ChevronLeft className="h-4 w-4" />
          Previous
        </Button>
        <span className="text-muted-foreground">
          Page {page + 1} of {pages}
        </span>
        <Button
          variant="outline"
          size="sm"
          disabled={!hasNext}
          onClick={() => onPageChange((page + 1) * limit)}
        >
          Next
          <ChevronRight className="h-4 w-4" />
        </Button>
      </div>
    </div>
  );
}
